<template>
  <div>
    <br />
    <div class v-if="data.data && data.data.length > 0">
      <a href data-toggle="modal" @click="download()">
        <button
          class="btn btn-outline-brand m-btn m-btn--outline"
          :disabled="!formIsValid"
        >
          <i class="fas fa-download"></i> Baixar
        </button>
      </a>
    </div>
    <div>
      <div class="page-amounts">
        <nav aria-label="...">
          <ul class="pagination pagination-md">
            <li class="page-item" :class="{ selected: amount === 3 }">
              <a @click="amount = 3" class="page-link paginate">3</a>
            </li>
            <li class="page-item" :class="{ selected: amount === 10 }">
              <a @click="amount = 10" class="page-link paginate">10</a>
            </li>
            <li class="page-item" :class="{ selected: amount === 50 }">
              <a @click="amount = 50" class="page-link paginate">50</a>
            </li>
            <li class="page-item" :class="{ selected: amount === 100 }">
              <a @click="amount = 100" class="page-link paginate">100</a>
            </li>
            <li class="page-item" :class="{ selected: amount === 150 }">
              <a @click="amount = 150" class="page-link paginate">150</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="paginator-info-top m-2">
        <span class="m--font-gray" v-if="data.from"
          >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
          {{ data.total }}.</span
        >
        <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
      </div>
    </div>
    <div class="container-table">
      <table
        class="table table-striped- table-bordered table-hover table-checkable"
      >
        <caption></caption>
        <thead>
          <tr>
            <th
              class="text-center align-middle pointer"
              style="white-space: nowrap, width:70"
              :class="{ 'table-sorted': sortType == 'co_id' }"
              @click="sortCall('co_id')"
            >
              ID Cliente
              <span
                class="fas fa-caret-down sorted"
                v-if="sortType == 'co_id' && !sortReverse"
              ></span>
              <span
                class="fas fa-caret-up sorted"
                v-if="sortType == 'co_id' && sortReverse"
              ></span>
              <span class="fal fa-sort sort" v-if="sortType != 'co_id'"></span>
            </th>
            <th
              style="white-space: nowrap, width:100"
              class="text-center align-middle pointer"
            >
              Cliente
            </th>
            <th
              class="text-center align-middle pointer"
              style="white-space: nowrap, width:60"
              :class="{ 'table-sorted': sortType == 'billing_month' }"
              @click="sortCall('billing_month')"
            >
              Mês
              <span
                class="fas fa-caret-down sorted"
                v-if="sortType == 'billing_month' && !sortReverse"
              ></span>
              <span
                class="fas fa-caret-up sorted"
                v-if="sortType == 'billing_month' && sortReverse"
              ></span>
              <span
                class="fal fa-sort sort"
                v-if="sortType != 'billing_month'"
              ></span>
            </th>
            <th
              class="text-center align-middle pointer"
              style="white-space: nowrap, width:20"
              :class="{ 'table-sorted': sortType == 'price_total' }"
              @click="sortCall('price_total')"
            >
              Valor
              <span
                class="fas fa-caret-down sorted"
                v-if="sortType == 'price_total' && !sortReverse"
              ></span>
              <span
                class="fas fa-caret-up sorted"
                v-if="sortType == 'price_total' && sortReverse"
              ></span>
              <span
                class="fal fa-sort sort"
                v-if="sortType != 'price_total'"
              ></span>
            </th>
            <th
              style="white-space: nowrap, width:120"
              class="text-center align-middle"
            >
              CNPJ
            </th>
            <th
              style="white-space: nowrap, width:20"
              class="text-center align-middle"
            >
              Tipo
            </th>
            <th
              style="white-space: nowrap, width:20"
              class="text-center align-middle"
            >
              Produto
            </th>
            <th
              style="white-space: nowrap, width:20"
              class="text-center align-middle"
            >
              Status
            </th>
            <th
              style="white-space: nowrap, width:20"
              class="text-center align-middle"
            >
              Data Faturamento
            </th>
            <th
              style="white-space: nowrap, width:20"
              class="text-center align-middle"
            >
              Categorias
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <input
                type="text"
                class="form-control form-control-sm m-input"
                v-model="filters.id"
                v-b-tooltip.hover
                title="Filtrar por ID do Cliente"
              />
            </td>
            <td>
              <input
                type="text"
                class="form-control form-control-sm m-input"
                v-model="filters.name"
                v-b-tooltip.hover
                title="Filtrar por nome do Cliente"
              />
            </td>
            <td>
              <SelectInvoiceBillingMonth
                :selected="filters.month"
                @change="setFilter('month', $event)"
                class="form-control-sm"
                v-b-tooltip.hover
                title="Filtrar por mês de cobrança"
              />
            </td>
            <td>
              <input
                type="text"
                class="form-control form-control-sm m-input"
                v-model="filters.price"
                v-b-tooltip.hover
                title="Filtrar por valor total"
              />
            </td>
            <td>
              <input
                type="text"
                class="form-control form-control-sm m-input"
                v-model="filters.document"
              />
            </td>
            <td>
              <SelectInvoiceTypes
                :selected="filters.type"
                @change="setFilter('type', $event)"
                class="form-control-sm"
                v-b-tooltip.hover
                title="Filtrar por tipo"
              />
            </td>
            <td>
              <SelectProducts
                :selected="filters.products"
                @change="setFilter('product', $event)"
                class="form-control-sm"
                v-b-tooltip.hover
                title="Filtrar por Produtos"
              />
            </td>
            <td>
              <SelectInvoiceStatuses
                :selected="filters.status"
                @change="setFilter('status', $event)"
                class="form-control-sm"
                v-b-tooltip.hover
                title="Filtrar por status"
              />
            </td>
            <td>
              <div class="input-group">
                <input
                  type="date"
                  name="start"
                  id="startj"
                  max="9999-12-31"
                  class="form-control form-control-sm m-input"
                  v-model="filters.billingDateExternal"
                />
              </div>
            </td>
            <td>
              <SelectCategories
                :selected="filters.categories"
                @change="setFilter('category', $event)"
                class="form-control-sm"
                v-b-tooltip.hover
                title="Filtrar por Categorias"
                id="selectCategories"
              />
            </td>
          </tr>
          <tr v-for="(invoice, id) in data.data" :key="id">
            <td class="text-center align-middle">
              {{ invoice.company ? invoice.company.id : invoice.customer.id }}
            </td>
            <td class="text-left align-middle">
              {{
                invoice.company
                  ? invoice.company.name
                  : invoice.customer.customerable.co_name
                  ? invoice.customer.customerable.co_name
                  : invoice.customer.customerable.name
              }}
            </td>
            <td class="text-center align-middle">
              {{ invoice.billing_month | month }}
            </td>
            <td class="text-right align-middle">
              {{
                invoice.discount > invoice.price_total + invoice.price_extra
                  ? 0
                  : (invoice.price_total +
                      invoice.price_extra -
                      invoice.discount)
                    | money
              }}
            </td>
            <td class="text-center align-middle">
              {{
                invoice.customer
                  ? invoice.customer.documents.value
                  : invoice.company
                  ? invoice.company.cnpj
                  : '' | cnpj | cpf
              }}
            </td>

            <td class="text-center align-middle">
              {{ invoice.contr_id ? 'Fatura Recorrente' : 'Fatura Avulsa' }}
            </td>
            <td class="text-center align-middle">{{ invoice.product.name }}</td>
            <td class="text-left align-middle">
              <span class="text-center align-middle" v-if="invoice.status == 0"
                >Não Conferida</span
              >
              <span class="text-center align-middle" v-if="invoice.status == 1"
                >Conferida</span
              >
              <span class="text-center align-middle" v-if="invoice.status == 2"
                >Venda Gerada</span
              >
              <span class="text-center align-middle" v-if="invoice.status == 3"
                >Cancelada</span
              >
            </td>
            <td
              class="text-center align-middle"
              v-bind:class="{
                bgPlan: invoice.plan_id != null,
                bgSpreadsheet: invoice.is_csv_consumption,
              }"
            >
              {{ invoice.billing_date_external | date }}
            </td>
            <td class="text-left align-middle">
              {{ invoice.category }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div>
      <div class="paginator-info-bottom mt-2">
        <span class="m--font-gray" v-if="data.from"
          >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
          {{ data.total }}.</span
        >
        <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
      </div>
      <div class="paginator-list">
        <nav aria-label="...">
          <ul class="pagination pagination-md">
            <li
              class="page-item"
              :class="{ disabled: data.current_page === 1 }"
            >
              <a class="page-link paginate" @click="page = 1">
                <i class="fal fa-angle-double-left"></i>
              </a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page === 1 }"
            >
              <a
                class="page-link paginate"
                @click="page = data.current_page - 1"
              >
                <i class="fal fa-angle-left"></i>
              </a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page === 1 }"
              v-if="data.current_page > 2"
            >
              <a
                class="page-link paginate"
                @click="page = data.current_page - 2"
                >{{ data.current_page - 2 }}</a
              >
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page === 1 }"
              v-if="data.current_page > 1"
            >
              <a
                class="page-link paginate"
                @click="page = data.current_page - 1"
                >{{ data.current_page - 1 }}</a
              >
            </li>
            <li class="page-item selected">
              <a class="page-link paginate">{{ data.current_page }}</a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page === data.last_page }"
              v-if="data.current_page < data.last_page"
            >
              <a
                class="page-link paginate"
                @click="page = data.current_page + 1"
                >{{ data.current_page + 1 }}</a
              >
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page + 1 === data.last_page }"
              v-if="data.current_page + 1 < data.last_page"
            >
              <a
                class="page-link paginate"
                @click="page = data.current_page + 2"
                >{{ data.current_page + 2 }}</a
              >
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page === data.last_page }"
            >
              <a
                class="page-link paginate"
                @click="page = data.current_page + 1"
              >
                <i class="fal fa-angle-right"></i>
              </a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page === data.last_page }"
            >
              <a class="page-link paginate" @click="page = data.last_page">
                <i class="fal fa-angle-double-right"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';
import SelectInvoiceBillingMonth from '@/components/forms/SelectInvoiceBillingMonth';
import SelectInvoiceStatuses from '@/components/forms/SelectInvoiceStatuses';
import SelectInvoiceTypes from '@/components/forms/SelectInvoiceTypes';
import SelectProducts from '@/components/forms/SelectProducts';
import SelectCategories from '@/components/forms/SelectCategories';
import GenerateSalePerGroup from '@/components/invoices/GenerateSalePerGroup';
import { Money } from 'v-money';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'ReportCategory',
  props: ['start', 'finish'],
  components: {
    Money,
    SelectInvoiceBillingMonth,
    SelectInvoiceStatuses,
    SelectInvoiceTypes,
    SelectProducts,
    GenerateSalePerGroup,
    SelectCategories,
  },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      currentCompanyDiscountName: '',
      data: {},
      sortType: localStorage.customerDiscountSortType
        ? localStorage.customerDiscountSortType
        : 'id',
      sortReverse: localStorage.customerDiscountSortReverse
        ? localStorage.customerDiscountSortReverse
        : false,
      amount: localStorage.customerDiscountDataAmount
        ? localStorage.customerDiscountDataAmount
        : 100,
      page: localStorage.customerDiscountDataPage
        ? localStorage.customerDiscountDataPage
        : 1,
      filters: {
        id: localStorage.customerDiscountFilterId
          ? localStorage.customerDiscountFilterId
          : '',
        name: localStorage.customerDiscountFilterName
          ? localStorage.customerDiscountFilterName
          : '',
        amount: localStorage.customerDiscountFilterAmount
          ? localStorage.customerDiscountFilterAmount
          : '',
        startDate: localStorage.startDate ? localStorage.startDate : '',
        finishDate: localStorage.finishDate ? localStorage.finishDate : '',
        billingDateExternal: localStorage.billingDateExternal
          ? localStorage.billingDateExternal
          : '',
        category: localStorage.category ? localStorage.category : '',
      },
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showCreateDiscount() {
      return this.$store.state.showCreateDiscount;
    },
    showCompanyDiscount() {
      return this.$store.state.showCompanyDiscount;
    },
    formIsValid() {
      return !!this.start;
    },
  },
  methods: {
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
    },
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    download() {
      const url = `${baseApiUrl}/v1/report/invoice/categories/download/${this.convertFilters()}`;

      axios
        .get(url)
        .then((res) => {
          const arrData = res.data;

          let csvContent = 'data:text/csv;charset=utf-8,';
          csvContent += [
            Object.keys(arrData[0]).join(';'),
            ...arrData.map((item) => String(Object.values(item).join(';'))),
          ]
            .join('\n')
            .replace(/(^\[)|(\]$)/gm, '');

          const data = encodeURI(csvContent);
          const link = document.createElement('a');
          link.setAttribute('href', data);

          let fileName = `relatorio_faturas`;

          if (this.start) {
            fileName += `_${this.start}-${this.finish}`;
          }

          fileName = `${fileName}.csv`;

          link.setAttribute('download', fileName);
          link.click();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    generate() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Gerando o relatório...',
        reason: '',
      };
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('customerDiscountFilterId', this.filters.id);
      localStorage.setItem('customerDiscountFilterName', this.filters.name);
      localStorage.setItem('customerDiscountFilterAmount', this.filters.amount);
      localStorage.setItem('customerDiscountDataAmount', this.amount);
      localStorage.setItem('customerDiscountDataPage', this.page);
      localStorage.setItem('customerDiscountSortType', this.sortType);
      localStorage.setItem('customerDiscountSortReverse', this.sortReverse);
    },
    convertFilters() {
      return `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&name=${this.filters.name ? this.filters.name : ''}&document=${
        this.filters.document ? this.filters.document : ''
      }&group=${this.filters.group ? this.filters.group : ''}&month=${
        this.filters.month ? this.filters.month : ''
      }&price=${this.filters.price ? this.filters.price : ''}&type=${
        this.filters.type ? this.filters.type : -1
      }&status=${this.filters.status ? this.filters.status : -1}&product=${
        this.filters.product ? this.filters.product : ''
      }&amount=${this.amount}&sortType=${this.sortType}&sortOrder=${
        this.sortReverse ? 'DESC' : 'ASC'
      }&start=${this.start}&end=${this.finish}
      &billing_date_external=${
        this.filters.billingDateExternal ? this.filters.billingDateExternal : ''
      }&category=${this.filters.category ? this.filters.category : ''}`;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType === sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      const timeWindow = 700;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.data.current_page = null;
        this.setStorageFilters();
        this.getDatas();
      }, timeWindow);
    },
    getDatas() {
      this.getFilteredData();
    },
    getFilteredData() {
      console.log('aqui');
      const url = `${baseApiUrl}/v1/report/invoice/categories${this.convertFilters()}`;

      axios
        .get(url)
        .then((res) => {
          this.data = res.data;
          this.clearAlert();
          this.$emit('updateLoading');
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
  },
  watch: {
    amount() {
      if (this.page === 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
};
</script>
